import { StoryBlokRichText } from '@cinch-nx/data-storyblok'

export function isStoryblokRichText(
  body: StoryBlokRichText | React.ReactNode,
): body is StoryBlokRichText {
  return (
    typeof body === 'object' &&
    body !== null &&
    (body as StoryBlokRichText).type === 'doc' &&
    Array.isArray((body as StoryBlokRichText).content)
  )
}
